import { flow } from 'lodash';
import PersonalityQuiz from './PersonalityQuiz';
import withUserInput from '../../hocs/UserInput';
// import withValidation from '../../hocs/Validation';
// import withPager from '../../hocs/Pager';
import { withRouter } from 'react-router-dom';

export default flow(
  withUserInput,
  withRouter /*withValidation, withPager */
)(PersonalityQuiz);



// WEBPACK FOOTER //
// ../core/src/components/PersonalityQuiz/index.js